// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { observable, action, makeObservable } from 'mobx';

export interface CustomerDTO {
  id: number;
  name: string;
  code: string;
  ordersAmount: number;
  jobRequestsAmount: number;
  assetsAmount: number;
  customerUsersAmount: number;
  isBlocked?: boolean;
  isActive?: boolean;
}

export class Customer {
  id: number = 0;
  name: string = '';
  code: string = '';
  ordersAmount: number = 0;
  jobRequestsAmount: number = 0;
  assetsAmount: number = 0;
  customerUsersAmount: number = 0;
  @observable isBlocked: boolean = false;
  @observable isActive: boolean = false;

  constructor(dto?: CustomerDTO) {
    if (dto !== undefined) {
      this.update(dto);
    }
    makeObservable(this);
  }

  get asJson(): CustomerDTO {
    return {
      id: this.id,
      name: this.name,
      code: this.code,
      ordersAmount: this.ordersAmount,
      jobRequestsAmount: this.jobRequestsAmount,
      assetsAmount: this.assetsAmount,
      customerUsersAmount: this.customerUsersAmount,
      isBlocked: this.isBlocked,
      isActive: this.isActive
    };
  }

  @action update(newData: Partial<CustomerDTO>): CustomerDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}